import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, Signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { DevcycleService, FEATURE_FLAGS } from '@app/services/devcycle.service';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [CommonModule, RouterOutlet, MatListModule, RouterLink, RouterLinkActive],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
})
export class AccountComponent implements OnInit {
  showWalletSettings = signal(false);

  constructor(
    private authService: AuthService,
    private router: Router,
    private devcycleService: DevcycleService,
  ) {
    this.authService.whenNotAuthenticated(() => {
      this.router.navigate(['/']);
    });
  }

  ngOnInit() {
    this.showWalletSettings.set(this.devcycleService.getFeatureFlag(FEATURE_FLAGS.WALLET_SETTINGS_ENABLE, false));
    this.devcycleService.onVariableUpdated(FEATURE_FLAGS.WALLET_SETTINGS_ENABLE, (key, value) => {
      this.showWalletSettings.set(value);
    });
  }
}
